import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationService} from '../../authenticationModule/services/authentication.service';
import {environment} from '../../../environments/environment';
import * as L from 'leaflet';
import {MapService} from '../../services/map.service';
import {MenuItem} from 'primeng/api';
import {BaseClientComponent} from '../base-client.component';
import {UtilsService} from '../../appSharedModule/services/utils.service';

@Component({
  selector: 'app-weather-map',
  templateUrl: './weather-map.component.html',
  styleUrls: ['./weather-map.component.css']
})
export class WeatherMapComponent extends BaseClientComponent implements OnInit, OnDestroy {
  region = '';
  regionList = ['us', 'toronto', 'eu', 'london', 'tokyo', 'mumbai'];
  private windyApiKey = environment.apiProdKeyWindy !== '' ? environment.apiProdKeyWindy : environment.apiDevKeyWindy;
  private regionColors = {
    us: 'RoyalBlue',
    toronto: 'DarkGreen',
    eu: 'DarkRed',
    london: 'DarkOrchid',
  };
  regionCoordination = [
    {
      region: 'us',
      center: {lat: 41.504454, lon: -81.100713},
      zoom: 6,
    },
    {
      region: 'eu',
      center: {lat: 48.8566, lon: 2.3522},
      zoom: 6,
    },
    {
      region: 'london',
      center: {lat: 51.556614, lon: 0.1022219},
      zoom: 9,
    },
    {
      region: 'tokyo',
      center: {lat: 23.574486, lon: 120.498678},
      zoom: 4,
    },
    {
      region: 'mumbai',
      center: {lat: 44.774555, lon: 11.914013},
      zoom: 5,
    },
    {
      region: 'toronto',
      center: {lat: 42.859859, lon: -83.983413},
      zoom: 6,
    },
  ];
  items: MenuItem[];

  constructor(private route: ActivatedRoute,
              private router: Router,
              private authenticationService: AuthenticationService,
              private mapService: MapService,
              private utilsService: UtilsService) {
    super();
  }

  ngOnInit() {
    this.subscriptions.push(this.route.paramMap.subscribe(params => {
      this.region = params.get('region');
      if (!this.regionList.includes(this.region)) {
        this.redirectionToNotFound();
      } else {
        this.OpenWeatherMap(this.region);
      }
    }));
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.mapService.clearMap();
  }

  selectRegion(region: string) {
    this.router.navigate(['/weather-map', region]);
  }


  getUserCurrent() {
    return this.authenticationService.getUserCurrent();
  }

  redirectionToNotFound() {
    this.utilsService.redirectToNotFound();
  }


  OpenWeatherMap(region: string) {
    const selectedRegion = this.regionCoordination.find((coord) => coord.region === region);
    if (selectedRegion) {
      this.region = region;
      this.subscriptions.push(this.mapService
        .initializeWindyMap(this.windyApiKey, selectedRegion.center.lat, selectedRegion.center.lon, selectedRegion.zoom)
        .subscribe(() => {
          this.loadAllMapData();
          this.mapService.updateMapCenter(selectedRegion.center.lat, selectedRegion.center.lon, selectedRegion.zoom);
        }));
    }
  }

  loadAllMapData() {
    this.regionCoordination.forEach(coord => {
      this.subscriptions.push(this.mapService.getRoutes(coord.region).subscribe((data: any) => {
        if (coord.region !== 'tokyo') {
          this.addTrajectory(data);
        } else {
          this.addMarkerForTokyoMap(data);
        }
      }));
    });
  }

  addTrajectory(data: any) {
    const color = this.regionColors[data.mapName];
    for (let i = 0; i < data.routes.length; i++) {
      const route = data.routes[i];
      const origin_lon = parseFloat(route.origin_lon);
      const origin_lat = parseFloat(route.origin_lat);
      const dest_lon = parseFloat(route.dest_lon);
      const dest_lat = parseFloat(route.dest_lat);
      if (!isNaN(origin_lon) && !isNaN(origin_lat) && !isNaN(dest_lon) && !isNaN(dest_lat)) {
        const startPoint: L.LatLngLiteral = {lat: origin_lat, lng: origin_lon};
        const endPoint: L.LatLngLiteral = {lat: dest_lat, lng: dest_lon};

        this.mapService.addTrajectoryLine(startPoint, endPoint, color);
      }
    }
  }

  addMarkerForTokyoMap(data: any) {
    for (const route of data.routes) {
      const origin_lon = parseFloat(route.origin_lon);
      const origin_lat = parseFloat(route.origin_lat);
      const markerPoint: L.LatLngLiteral = {lat: origin_lat, lng: origin_lon};
      this.mapService.addMarker(markerPoint);
    }
  }
}
